<template>
    <ul>
        <li style="color:white" v-for="(message, index) in messages" :key="index">
            {{ message.text }}
        </li>
    </ul>
</template>

<script>
import { mapGetters } from 'vuex';
import { HUB_NAMES, SIGNALR_CONNECTION_STATE } from '@/utils/constants';

export default {
    name: 'Demo',
    data() {
        return {
            // signalR
            connection: null,
            messages: [],
            expandNews: false,
            expandSingle: false,
            lastSeenPerson: '',
            signalRHandlers: [],
            signalRTimeout: null
        };
    },
    async mounted() {
        // Set up SignalR handlers
        this.signalRHandlers = [
            {
                action: 'Detected',
                handler: this.detected
            }
        ];

        await this.setupSignalR();
    },
    beforeDestroy() {
        clearTimeout(this.signalRTimeout);
        this.removeSignalRHandlers();
    },
    computed: {
        ...mapGetters({
            getConnectionStatus: 'signalR/getConnectionStatus',
            getConnection: 'signalR/getConnection'
        })
    },
    methods: {
        async setupSignalR() {
            try {
                await this.$store.dispatch('signalR/connect', HUB_NAMES.LocationHub);
                const connection = this.getConnection(HUB_NAMES.LocationHub);

                // Verify connection is established before proceeding
                if (!connection || connection.state !== SIGNALR_CONNECTION_STATE.Connected) {
                    throw new Error('SignalR connection not established');
                }

                await this.$store.dispatch('signalR/registerHandlers', {
                    hubName: HUB_NAMES.LocationHub,
                    handlers: this.signalRHandlers
                });
            } catch (e) {
                console.error('Error connecting to location hub:', e);
            }
        },
        removeSignalRHandlers() {
            try {
                const connection = this.getConnection(HUB_NAMES.LocationHub);

                if (connection && connection.state === SIGNALR_CONNECTION_STATE.Connected) {
                    this.$store.dispatch('signalR/unregisterHandlers', {
                        hubName: HUB_NAMES.LocationHub,
                        handlers: this.signalRHandlers
                    });
                }
            } catch (error) {
                console.error('Error removing SignalR handlers:', error);
            }
        },
        parseName(val) {
            const parts = val.replace('.jpg', '').split('_');
            parts.forEach((part, index, object) => {
                if (!Number.isNaN(part)) 
                    object.splice(index, 1);
            }); // Remove _1, _2 etc
            return parts;
        },
        detected(val) {
            if (val.FaceSearchResponse) {
                val.FaceSearchResponse.forEach((res) => {
                    res.MatchedFaces.forEach((face) => {
                        const parts = this.parseName(face.Face.ExternalImageId);
                        const firstName = parts[0];
                        const fullName = parts.join(' ');
                        if (fullName !== this.lastSeenPerson) {
                            this.lastSeenPerson = fullName;
                            this.messages.push({
                                text: `Saw ${fullName}. Saying greeting`
                            });
                            window.speechSynthesis.speak(
                                new SpeechSynthesisUtterance(`Hello ${firstName}. How are you doing?`)
                            );
                        }
                    });
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
$list-width: 320px;

.full-control {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap-reverse;
}

.list {
    width: $list-width;
}

.full-control > .md-list {
    width: $list-width;
    max-width: 100%;
    height: 400px;
    display: inline-block;
    overflow: auto;
    border: 1px solid rgba(#000, 0.12);
    vertical-align: top;
}

.control {
    min-width: 250px;
    display: flex;
    flex-direction: column;
    padding: 16px;
}
</style>
